<router-outlet></router-outlet>
<div class="flex-content">
  <div class="content col-sm-12 container-fluid">
    <div class="row area no-gutters">
      <a [routerLink]="[ '/main/area/teams/', '7']" class="area-desc desc-07 col-sm-12">
        <h2 class="text-center">
          IMAGE & VIDEO
        </h2>
      </a>
      <a [routerLink]="[ '/main/area/teams/', '6']" class="area-desc desc-06 col-sm-12">
        <h2 class="text-center">
          FACE & BODY
        </h2>
      </a>
      <!-- <a [routerLink]="[ '/main/area/teams/', '3']" class="area-desc desc-03 col-sm-12">
        <h2 class="text-center">
          COMPUTING FOR LAZY LIFE
        </h2>
      </a> -->
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-area/research-area.component.html